import { SalesIconComponent } from 'assets/icons/sales';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'sales',
  label: 'Vendas',
  icon: SalesIconComponent()
};

export default generateResources(resource);
